import { GetAppSettings } from './AppSettings';

const LOCAL = 'LOCAL',
  DEV = 'DEV',
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  PRODUCTION = 'PRODUCTION';

export function GetProductionAuthReturnUrl() {
  return GetAuthReturnUrl(PRODUCTION);
}

export function GetAuthReturnUrl(environment = null) {
  const activeEnvironment = process.env.NODE_ENV !== 'production' ? LOCAL : GetAppSettings().Environment;
  const env = (environment || activeEnvironment).toUpperCase();
  switch (env) {
    case LOCAL:
      return `http://localhost:8080/App/AuthReturn`;
    case DEV:
      return `https://dev.goformz.com/App/AuthReturn`;
    case ALPHA:
      return `https://alpha.goformz.com/App/AuthReturn`;
    case BETA:
      return `https://beta.goformz.com/App/AuthReturn`;
    case PRODUCTION:
    default:
      return `https://app.goformz.com/App/AuthReturn`;
  }
}
